import App from "./App.tsx";
import appStore, { persistor } from "./Redux/AppStore.ts";
import { renderPicoApp } from "jadro-pico-app/App/renderPicoApp";
import { PicoComErrorResources } from "jadro-pico-app/Resources/errors/PicoComErrorResources";
import { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum";

renderPicoApp({
  store: appStore,
  persistor,
  clientId: PicoAppEnum.PICO_COM,
  errorResources: PicoComErrorResources,
  requiresAuth: false,
  children: <App />,
});
